module.exports = __webpack_public_path__ + "img/logo.124b62d1.png";